import { markRaw } from 'vue'
import ServiceTitanIcon from '@/components/icons/ServiceTitanIcon.vue'

/**
 * User dropdown menu configuration.
 * Each item can have a `show` function that receives the store to determine visibility.
 *
 * Role hierarchy:
 * - gmbAdmin (super admin): Gets admin links
 * - adminPrivileges (owner/admin): Full access to organization settings
 * - editor (member): Limited settings access
 * - viewer: No menu items, only Log Out
 */
export default [
  {
    label: 'Admin panel',
    href: '/admin/organizations',
    icon: 'fa-solid fa-users-gear',
    show: (store) => store.user.gmbAdmin,
    dividerAfter: true
  },
  {
    label: 'Organization',
    href: '/users',
    icon: 'fa-solid fa-building',
    show: (store) => store.user.adminPrivileges && !store.organization.sso
  },
  {
    label: 'Google Accounts',
    href: '/google_accounts',
    icon: 'fa-brands fa-google',
    show: (store) => store.user.editor
  },
  {
    label: 'Facebook Accounts',
    href: '/facebook_accounts',
    icon: 'fa-brands fa-facebook',
    show: (store) => store.user.editor && store.hasFeature('fb')
  },
  {
    label: 'ServiceTitan',
    href: '/service_titan/linking',
    iconComponent: markRaw(ServiceTitanIcon),
    show: (store) => store.user.editor && store.hasFeature('service_titan') && store.hasFeature('new_ui')
  },
  {
    label: 'GSC & GA4',
    href: '/gsc_ga4/gsc_properties',
    icon: 'fa-solid fa-chart-line',
    show: (store) => store.user.editor && store.hasFeature('gsc_ga4') && store.hasFeature('new_ui')
  },
  {
    label: 'Billing',
    href: '/billing/edit',
    icon: 'fa-solid fa-credit-card',
    show: (store) => store.user.owner && !store.organization.sso
  },
  {
    label: 'EXIF Templates',
    href: '/exif_templates',
    icon: 'fa-solid fa-image',
    show: (store) => store.user.editor && !store.organization.sso
  },
  {
    label: 'Help',
    href: (store) => store.wlc.helpCenterUrl,
    icon: 'fa-solid fa-circle-question',
    show: (store) => store.user.editor && !store.organization.sso,
    external: true
  },
  {
    label: 'Log Out',
    href: '/sign_out',
    icon: 'fa-solid fa-right-from-bracket',
    method: 'delete',
    show: (store) => !store.organization.sso,
    dividerBefore: true
  }
]
